import { useState, useEffect } from "react";
import presenceSocket from "../services/presenceSocket";

/**
 * usePresence Hook
 * Connects to the presence WebSocket, manages break status notifications,
 * and provides live active rep counts.
 */
export function usePresence({ role, companyCode, employeeId, autoBreak }) {
  const [presence, setPresence] = useState({
    activeOnline: 0,
    onBreak: 0,
    totalRegistered: 0,
    activeEmployeeIds: [],
    onBreakEmployeeIds: [],
  });

  // Connect to WebSocket when companyCode or role changes
  useEffect(() => {
    if (!companyCode) return;

    presenceSocket.connect();
    const unsubscribe = presenceSocket.subscribe((data) => {
      if (data && (!data.companyCode || data.companyCode === companyCode)) {
        setPresence((prev) => ({
          ...prev,
          ...data,
        }));
      }
    });

    return () => {
      unsubscribe();
    };
  }, [companyCode, role]);

  // Sync break status to WebSocket when onBreak changes (for employees)
  useEffect(() => {
    if (role === "employee" && autoBreak !== undefined) {
      presenceSocket.setBreakStatus(Boolean(autoBreak?.isOnBreak));
    }
  }, [role, autoBreak?.isOnBreak]);

  return presence;
}

export default usePresence;
